/*
 * Homepage a sezioni fullscreen.
 * Ogni .fs-section è un livello fisso; scrollando, quella corrente scivola in alto
 * e rivela la successiva. Emette `fs:change` con { index, bg } per l'header.
 */
(function () {
  var DURATION = 1100;
  var SWIPE_MIN = 50;
  var mqMobile = window.matchMedia('(max-width: 767px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var state = {
    sections: [],
    index: 0,
    locked: false,
    lastWheelAt: 0,
    lastWheelAbs: 0,
    touchY: null
  };

  function duration() {
    return reduceMotion.matches ? 50 : DURATION;
  }

  /* ---------- Chiaro / scuro ---------- */

  var lumaCache = {};

  function sampleLuma(src) {
    if (lumaCache[src]) return lumaCache[src];
    lumaCache[src] = new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var w = 40;
          var h = Math.max(1, Math.round(w * img.naturalHeight / img.naturalWidth));
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0, w, h);
          // Fascia alta: è lì che stanno header e logo
          var band = Math.max(1, Math.round(h * 0.2));
          var data = ctx.getImageData(0, 0, w, band).data;
          var sum = 0;
          for (var i = 0; i < data.length; i += 4) {
            sum += 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2];
          }
          resolve(sum / (data.length / 4) / 255);
        } catch (e) {
          resolve(null); // canvas bloccato da CORS
        }
      };
      img.onerror = function () { resolve(null); };
      img.src = src;
    });
    return lumaCache[src];
  }

  function sampleSources(section) {
    var mobile = mqMobile.matches;
    var out = [];
    section.querySelectorAll('[data-fs-sample]').forEach(function (el) {
      var target = el.getAttribute('data-fs-sample');
      if (target === 'mobile' && !mobile) return;
      if (target === 'desktop' && mobile) return;
      var src = el.currentSrc || el.src;
      if (src) out.push(src);
    });
    return out;
  }

  function resolveBg(section) {
    var setting = section.getAttribute('data-fs-bg') || 'auto';
    if (setting !== 'auto') {
      section._fsBg = setting;
      return Promise.resolve(setting);
    }
    var srcs = sampleSources(section);
    if (!srcs.length) {
      section._fsBg = 'dark';
      return Promise.resolve('dark');
    }
    return Promise.all(srcs.map(sampleLuma)).then(function (values) {
      var valid = values.filter(function (v) { return v !== null; });
      var avg = valid.length ? valid.reduce(function (a, b) { return a + b; }, 0) / valid.length : 0;
      section._fsBg = avg > 0.6 ? 'light' : 'dark';
      return section._fsBg;
    });
  }

  function whenImagesReady(section) {
    var imgs = section.querySelectorAll('img[data-fs-sample]');
    return Promise.all(Array.prototype.map.call(imgs, function (img) {
      if (img.complete) return null;
      return new Promise(function (r) {
        img.addEventListener('load', r, { once: true });
        img.addEventListener('error', r, { once: true });
      });
    }));
  }

  function computeAllBgs() {
    state.sections.forEach(function (section, i) {
      whenImagesReady(section).then(function () { return resolveBg(section); }).then(function () {
        if (i === state.index) emit();
      });
    });
  }

  /* ---------- Render ---------- */

  function emit() {
    var section = state.sections[state.index];
    if (!section) return;
    var bg = section._fsBg || (section.getAttribute('data-fs-bg') !== 'auto' ? section.getAttribute('data-fs-bg') : 'dark');
    document.documentElement.setAttribute('data-fs-bg', bg);
    document.documentElement.setAttribute('data-fs-index', String(state.index));
    window.fsHome.index = state.index;
    document.dispatchEvent(new CustomEvent('fs:change', { detail: { index: state.index, bg: bg, section: section } }));
  }

  function render() {
    var n = state.sections.length;
    state.sections.forEach(function (section, i) {
      section.style.zIndex = String(n - i);
      section.classList.toggle('is-past', i < state.index);
      section.classList.toggle('is-current', i === state.index);
      section.classList.toggle('is-next', i === state.index + 1);
      section.classList.toggle('is-prev', i === state.index - 1);
      section.classList.toggle('is-hidden', Math.abs(i - state.index) > 1);
      section.setAttribute('aria-hidden', i === state.index ? 'false' : 'true');
      section.toggleAttribute('inert', i !== state.index);
      section.classList.toggle('fs-scrollable', section.scrollHeight > section.clientHeight + 2);
      playVideos(section, Math.abs(i - state.index) <= 1);
    });
    emit();
  }

  function playVideos(section, play) {
    section.querySelectorAll('video').forEach(function (v) {
      if (play) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });
  }

  function goTo(i) {
    var n = state.sections.length;
    i = Math.max(0, Math.min(n - 1, i));
    if (i === state.index || state.locked) return;
    state.index = i;
    state.locked = true;
    render();
    setTimeout(function () {
      state.locked = false;
      state.lastWheelAt = Date.now();
    }, duration());
  }

  function next() { goTo(state.index + 1); }
  function prev() { goTo(state.index - 1); }

  /* ---------- Input ---------- */

  // Lascia scorrere il contenuto interno (footer, social) prima di cambiare sezione
  function canScrollInside(section, dir) {
    if (!section || section.scrollHeight <= section.clientHeight + 2) return false;
    if (dir > 0) return section.scrollTop + section.clientHeight < section.scrollHeight - 2;
    return section.scrollTop > 0;
  }

  function ownsEvent(target) {
    // Ignora eventi dentro menu mobile, mega menu, popup, ecc.
    if (target.closest && target.closest('.mm-panel')) return false;
    return target === document.body || target === document.documentElement || !!(target.closest && target.closest('.fs-section, #shopify-section-header-biglogo'));
  }

  function onWheel(e) {
    if (!ownsEvent(e.target)) return;
    var dy = e.deltaY;
    var dir = dy > 0 ? 1 : -1;
    var current = state.sections[state.index];
    if (canScrollInside(current, dir)) return;
    e.preventDefault();

    var now = Date.now();
    var abs = Math.abs(dy);
    var gap = now - state.lastWheelAt;
    state.lastWheelAt = now;
    var prevAbs = state.lastWheelAbs;
    state.lastWheelAbs = abs;

    if (state.locked || abs < 4) return;
    // Coda d'inerzia del trackpad: intensità in calo e senza pause → la ignoriamo
    if (gap < 200 && abs <= prevAbs) return;
    dir > 0 ? next() : prev();
  }

  function onTouchStart(e) {
    if (!ownsEvent(e.target)) { state.touchY = null; return; }
    state.touchY = e.touches[0].clientY;
  }

  function onTouchMove(e) {
    if (state.touchY === null) return;
    var dir = state.touchY - e.touches[0].clientY > 0 ? 1 : -1;
    if (canScrollInside(state.sections[state.index], dir)) return;
    if (e.cancelable) e.preventDefault();
  }

  function onTouchEnd(e) {
    if (state.touchY === null) return;
    var dy = state.touchY - e.changedTouches[0].clientY;
    state.touchY = null;
    if (Math.abs(dy) < SWIPE_MIN) return;
    var dir = dy > 0 ? 1 : -1;
    if (canScrollInside(state.sections[state.index], dir)) return;
    dir > 0 ? next() : prev();
  }

  function onKey(e) {
    var tag = (e.target.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || tag === 'select' || e.target.isContentEditable) return;
    var current = state.sections[state.index];
    switch (e.key) {
      case 'ArrowDown':
      case 'PageDown':
        if (canScrollInside(current, 1)) return;
        e.preventDefault(); next(); break;
      case ' ':
        if (canScrollInside(current, e.shiftKey ? -1 : 1)) return;
        e.preventDefault(); e.shiftKey ? prev() : next(); break;
      case 'ArrowUp':
      case 'PageUp':
        if (canScrollInside(current, -1)) return;
        e.preventDefault(); prev(); break;
      case 'Home': e.preventDefault(); goTo(0); break;
      case 'End': e.preventDefault(); goTo(state.sections.length - 1); break;
    }
  }

  /* ---------- Setup ---------- */

  function isVisible(el) {
    return el.getClientRects().length > 0 && getComputedStyle(el).display !== 'none';
  }

  function collect() {
    // Solo le sezioni visibili: alcune esistono in versione desktop o mobile
    var all = Array.prototype.slice.call(document.querySelectorAll('.fs-section'));
    state.sections = all.filter(isVisible);
    all.forEach(function (s) {
      if (state.sections.indexOf(s) === -1) {
        s.classList.remove('is-past', 'is-current', 'is-next', 'is-prev');
        s.style.zIndex = '';
      }
    });
  }

  function init() {
    collect();
    if (!state.sections.length) {
      document.documentElement.classList.remove('fs-mode');
      return;
    }
    document.documentElement.classList.add('fs-mode');
    state.index = Math.min(state.index, state.sections.length - 1);
    render();
    computeAllBgs();
  }

  function indexOfEditorSection(evt) {
    var wrapper = document.getElementById('shopify-section-' + evt.detail.sectionId);
    var section = wrapper && (wrapper.matches('.fs-section') ? wrapper : wrapper.querySelector('.fs-section'));
    if (!section) return -1;
    var visible = wrapper.querySelectorAll('.fs-section');
    for (var k = 0; k < visible.length; k++) {
      if (state.sections.indexOf(visible[k]) !== -1) return state.sections.indexOf(visible[k]);
    }
    return -1;
  }

  window.fsHome = { index: 0, goTo: goTo, next: next, prev: prev, refresh: init };

  document.addEventListener('DOMContentLoaded', function () {
    init();

    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('touchend', onTouchEnd, { passive: true });
    window.addEventListener('keydown', onKey);
    window.addEventListener('resize', function () {
      state.sections.forEach(function (s) {
        s.classList.toggle('fs-scrollable', s.scrollHeight > s.clientHeight + 2);
      });
    });
    mqMobile.addEventListener('change', function () {
      // Il set di schermate cambia (Duo: 1 desktop <-> 2 mobile): si resta nella stessa sezione
      var cur = state.sections[state.index];
      var wrapper = cur && cur.closest('.shopify-section');
      state.sections.forEach(function (s) { s._fsBg = null; });
      collect();
      var keep = -1;
      if (wrapper) {
        for (var k = 0; k < state.sections.length; k++) {
          if (wrapper.contains(state.sections[k])) { keep = k; break; }
        }
      }
      if (keep >= 0) state.index = keep;
      init();
    });

    // Theme editor
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', function () { setTimeout(init, 0); });
    document.addEventListener('shopify:section:reorder', init);
    // Blocchi con duplicato desktop/mobile: va alla schermata visibile
    document.addEventListener('shopify:block:select', function (evt) {
      collect();
      var els = document.querySelectorAll('[data-shopify-editor-block="' + evt.detail.blockId + '"]');
      for (var k = 0; k < els.length; k++) {
        var i = state.sections.indexOf(els[k].closest('.fs-section'));
        if (i >= 0) { state.locked = false; goTo(i); return; }
      }
    });
    document.addEventListener('shopify:section:select', function (evt) {
      collect();
      var i = indexOfEditorSection(evt);
      if (i < 0) return;
      state.locked = false;
      goTo(i);
    });
  });
})();
